<template>
  <div class="flex flex-col">
    <div class="w-full flex flex-row gap-2 nxp-nav-container mb-8">
      <button v-for="(button, index) in buttons" :key="index" @click="() => changeButton(index)" class="nxp-nav-button"
        :class="button.activated ? 'nxp-nav-button-active' : ''"
        :style="button.activated ? { borderColor: color } : ''">
        <p>{{ button.label }}</p>
      </button>
    </div>
    <div v-if="buttons[0].activated">
      <SettingsPage />
    </div>
    <div v-else-if="buttons[1].activated">
      <div class="profile-visibility-section">
        <h2>Visibilidade do perfil</h2>
        <p>A Recrutei conecta empresas e candidatos para facilitar a geração de empregos no Brasil.</p>
        <p>Com 1 cadastro, seu perfil pode ser visto por milhares de recrutadores diariamente, o que aumenta suas chances de conseguir um emprego.</p>
        <p>Se preferir que apenas as empresas da qual você se já se candidatou para vagas vejam seu perfil, desative a visibilidade do seu perfil na Base Recrutei abaixo, para ocultá-lo de outros recrutadores.</p>
        <div class="control-switch">
          <h2>Perfil visível na Base Recrutei</h2>
          <div>
            <vs-switch :color="color" :value="is_public" @input="handleChangeSwitch" />
          </div>
        </div>
        <p>Seu perfil
          <strong v-if="is_public">está visível</strong>
          <strong v-else>não está visível</strong>
          está visível para recrutadores. </p>
        <p v-if="is_public">
          Você poderá ser encontrado por milhares de recrutadores e receber convites por e-mail ou Whatsapp para participar de processos seletivos.
        </p>
        <p v-else>
          Ative a visibilidade do seu perfil para ser encontrado por milhares de recrutadores e receber convites por e-mail ou Whatsapp para participar de processos seletivos. 
        </p>
        <p>Estes recrutadores só terão acesso a suas informações de contato quando você aceitar um convite para um processo seletivo.</p>
        <a
          href="https://recrutei.com.br/privacidade-e-seguranca"
          target="_blank"
          class="conditions__link"
          >Política de privacidade</a>
      </div>
    </div>
    <div v-else-if="buttons[2].activated">
      <PushNotificationsSettings :color="color" />
    </div>
    <div v-else-if="buttons[3].activated">
      <PublicProfileSettings />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SettingsPage from "../pages/Settings.vue"
import PushNotificationsSettings from "../../components/dashboard/PushNotificationsSettings.vue"
import PublicProfileSettings from "../../components/dashboard/PublicProfileSettings.vue"
export default {
  watch: {
    '$route.query.tab': function(tab) {
      this.applyTab(tab);
    }
  },
  created() {
    window.scroll(0, 0);
    this.googleAnalytics();
    this.fetchPublicStatus();
    this.checkTabQuery();
  },
  data() {
    return {
      buttons: [
        {
          label: "Configurações",
          activated: true,
        },
        {
          label: "Visibilidade do perfil",
          activated: false,
        },
        {
          label: "Avisos de vaga",
          activated: false,
        },
        {
          label: "Perfil público",
          activated: false,
        },
      ],
      is_public: false,
    };
  },
  computed: {
    ...mapState("company", ["company"]),
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    colorSoft() {
      if (this.vacancy_status === 1)
        return this.company.base_hexcolor
          ? this.company.base_hexcolor + '2E'
          : "#1551b12E";
      else
        return this.company.base_hexcolor;
    },
  },
  methods: {
    changeButton(i) {
      this.buttons.map((button, index) => {
        if (index === i) {
          button.activated = true;
        } else {
          button.activated = false;
        }
      });
    },

    googleAnalytics() {
      const { company_label } = this.$router.history.current.params;
      this.$ga.page(`${company_label}/settings`);
    },

    async fetchPublicStatus() {
      this.$vs.loading({
        text: "Verificando Visibilidade do Perfil",
      });
      try {
        const response = await this.$http.get("api/v2/talents/public/show");
        const { is_public = undefined } = response.data.data;

        if (!is_public) {
          this.is_public = false;
        } else {
          this.is_public = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleChangeSwitch(value) {
      this.is_public = value;
      try {
        this.$vs.loading({
        text: "Atualizando Visibilidade do Perfil",
      });
        if (value) {
          await this.$http.post("api/v2/talents/public/set-public");
          this.$vs.notify({
            title: "Parabéns!",
            text: "Agora você faz parte da Base Recrutei!",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
          });
        } else {
          await this.$http.post("api/v2/talents/public/destroy-public");
          this.$vs.notify({
            title: "Alteração realizada com sucesso!",
            text: "Você não faz mais parte da Base Recrutei.",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Ops!",
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    checkTabQuery() {
      this.applyTab(this.$route.query.tab);
    },
    // Aceita o indice (?tab=2) ou o nome da aba (?tab=perfil-publico, usado na
    // volta do portal de assinatura da Stripe).
    applyTab(tab) {
      if (tab === "perfil-publico") {
        this.changeButton(3);
        return;
      }
      if (tab || tab === 0 || tab === "0") {
        const index = parseInt(tab);
        if (!isNaN(index)) this.changeButton(index);
      }
    },
  },
  components: {
    SettingsPage,
    PushNotificationsSettings,
    PublicProfileSettings,
  },
};
</script>

<style lang="scss">
.nxp-nav-container {
  border-bottom: 0.5px solid #A8A8A8;
  background: #FFF;
  overflow-x: auto;
}

.nxp-nav-button {
  display: flex;
  padding: 16px 4px 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  background-color: white;
  color: #696969;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  flex-shrink: 0;
  border-bottom: 2px solid #FFF;
  transition: all 0.2s ease;
  cursor: pointer;
}

.nxp-nav-button-active {
  border-bottom: 2px solid #059742;
  color: #333;
}

.profile-visibility-section {
  width: 400px;
  margin: 24px auto;
  

  h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 23.44px;
    color: #333;
    margin-bottom: 20px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    color: #696969;
    margin-bottom: 20px;
  }

  .control-switch {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    gap: 8px;
    margin-top: 48px;
  }

  .conditions__link {
    font-size: 16px;
    font-weight: 400;
    line-height: 18.75px;
    text-decoration: underline;
    color: #4f4f4f;
    display:block;
    padding: 16px 0;
    margin-top: 32px;
  }
}
</style>